import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { useBot } from "./useBot"
import { Lead } from "@/interfaces/Lead"

const axios = useAxios()

export interface GetAllLeadsParams {
  page?: string
  perPage?: string
  search?: string
  groupId?: number
  paymentPlanId?: number
  subscriptionStatus?: 'active' | 'inactive'
  joinedAtFrom?: string
  joinedAtTo?: string
  lastPaymentAtFrom?: string
  lastPaymentAtTo?: string
  subscriptionExpiresAtFrom?: string
  subscriptionExpiresAtTo?: string
}

export function useLead() {
  const { selectedBot } = useBot()

  const getAll = async (params?: GetAllLeadsParams): Promise<Pagination<Lead>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/leads`, { params })

    return response.data
  }

  const getById = async (id: number): Promise<Lead> => {
    const response = await axios.get(`/bots/${selectedBot.value?.id}/leads/${id}`)

    return response.data
  }

  return {
    getAll,
    getById
  }
}